<app-header (click)="closeNav()"></app-header>

<app-side-nav class="side-nav"><ng-content></ng-content></app-side-nav>
